import React, {useCallback, useEffect, useMemo, useState,} from 'react';
import { array, arrayOf, object, oneOf, string, boolean ,} from 'prop-types';
import { Accordion, SimpleLoading, SimpleSelect, } from '~/components';
import {ChevronDown} from 'react-feather';
import {
  useFetch,
  useDebounce,
  useApi
} from '~/hooks';
import { useResultData } from '../../resultContext';
import RiskItem from '../RisksByTheme/RiskItem';
import { useTranslation } from 'react-i18next';
import { AlignDivs } from './styles'
import { useParams } from 'react-router-dom';
import useWebSocketRefresh from "~/hooks/useWebSocketRefresh";
import { useAlert } from "react-alert";

const ItemRiskListEntry = ({
  showFilters,
  itemRiskType,
  columns,
  data,
  fetchUrl,
}) => {
  const [shouldFetch, setShouldFetch] = useState(false);
  const [courts, setCourts] = useState([]);
  const [years, setYears] = useState([]);
  const [polarities, setPolarities] = useState([]);
  const [status, setStatus] = useState([])
  const [selectedCourts, setSelectedCourts] = useState(null);
  const [selectedYears, setSelectedYears] = useState(null);
  const [selectedPolarities, setSelectedPolarities] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const { t } = useTranslation('diligence');
  const { addMutation } = useResultData();
  const [url, setUrl] = useState(fetchUrl);
  const { data: myData, isValidating, mutate } = useFetch({
    url: (shouldFetch && url) ? url : null,
  });
  const cortes = useDebounce(selectedCourts, 2000)
  const anos = useDebounce(selectedYears, 2000)
  const polos = useDebounce(selectedPolarities, 2000)
  const postponeStatus = useDebounce(selectedStatus, 2000)

  const { id: processID } = useParams();
  const api = useApi();
  const { data: caseProgress, mutate: caseProgressMutate } = useFetch({ url: `/case-progress-calls?process_id=${processID}`});
  const alert = useAlert();

  useWebSocketRefresh({
    channel: 'App.Events.CaseProgressReady',
    events: [`App\\Events\\CaseProgressReady\\${processID}`],
    mutations: [
      caseProgressMutate,
    ],
  }, [caseProgress]);

  const caseProgressHandlerListRiskItems = useCallback(async (caseProgressStatus, processId, caseNumber, riskSourceID) => {

    caseNumber = caseNumber.slice(0, 20);
    
    if (caseProgressStatus === 'success') {
      const path = `/pesquisa/diligencia/${processID}/risk/${riskSourceID}/case-progress/${caseNumber}?q=cover`;
      window.open(path, '_blank', 'noopener,noreferrer');
    } else if(caseProgressStatus === 'error' || caseProgressStatus === 'not_called') {
    try {
      await api().get(`/process/${processID}/case-progress/${caseNumber}`);
    } catch (e) {
      alert.error(t('case_progress.case_progress_error'));
    } finally {
      alert.success(t('case_progress.case_progress_success'));
      }
    }
  }, []);

  const processedRiskItems = useMemo(() => {
    
    if (!myData) return null;
    if (!caseProgress) return myData;
    
    return myData.map(riskItem => {
      let caseProgressStatus = 'not_called';
      let caseProcessCall = caseProgress.find(
        caseProgressCall => caseProgressCall.case_number === riskItem.coluna2 && caseProgressCall.response_status !== null && caseProgressCall.response_status !== 200
      );
      if (caseProcessCall) {
        caseProgressStatus = 'error';
      }

      caseProcessCall = caseProgress.find(
        caseProgressCall => caseProgressCall.case_number === riskItem.coluna2 && caseProgressCall.response_status === null
      );
      if(caseProcessCall) {
        caseProgressStatus = 'loading';
      }
      
      caseProcessCall = caseProgress.find(
        caseProgressCall => caseProgressCall.case_number === riskItem.coluna2 && caseProgressCall.response_status === 200
      );
      if (caseProcessCall) {
        caseProgressStatus = 'success';
      }

      return {
        ...riskItem,
        caseProgressStatus: caseProgressStatus,
      };
    });
  }, [myData, caseProgress])

  useEffect(() => {
    if (url) addMutation(mutate);
  }, [addMutation, mutate, url]);

  const actualData = useMemo(() => {
    if (myData) return myData;
    if (data) return data;
    return [];
  }, [data, myData]);

  const onOpen = useCallback((isOpened) => {
    if (isOpened && ! shouldFetch && url) {
      setShouldFetch(true);
    }
  }, [shouldFetch, url]);

  const filterCourties = (<SimpleSelect
    isMulti
    icon={ChevronDown}
    value={selectedCourts}
    options={courts?.map((item) => ({
      value: item,
      label: item,
    }))}
    onChange={(val) => setSelectedCourts(val)}
    appearance="secondary"
    placeholder={t('filters.court') }
  />);

  const filterYears = (<SimpleSelect
    isMulti
    icon={ChevronDown}
    value={selectedYears}
    options={years?.map((item) => ({
      value: item,
      label: item,
    }))}
    onChange={(val) => setSelectedYears(val)}
    appearance="secondary"
    placeholder={t('filters.year') }
  />);

  const filterPolarities = (<SimpleSelect
    isMulti
    icon={ChevronDown}
    value={selectedPolarities}
    options={polarities?.map((item) => ({
      value: item,
      label: item,
    }))}
    onChange={(val) => setSelectedPolarities(val)}
    appearance="secondary"
    placeholder={t('filters.polarity')}
  />);

  const filterStatus = (<SimpleSelect
    isMulti
    icon={ChevronDown}
    value={selectedStatus}
    options={status?.map((item) => ({
      value: item,
      label: item,
    }))}
    onChange={(val) => setSelectedStatus(val)}
    appearance="secondary"
    placeholder={t('filters.status')}
  />)

  useEffect(() => {
    let filter = actualData;
    if (showFilters) {
      const temp =
        fetchUrl +
        `?coluna1=${JSON.stringify(cortes)}` +
        `&coluna2=${JSON.stringify(anos)}` +
        `&coluna3=${JSON.stringify(polos)}` +
        `&coluna4=${JSON.stringify(postponeStatus)}`
        ;
      setUrl(temp);
    }

    caseProgressMutate()
    
    const filterWithCaseProgress = filter?.map((item) => {

        const result = JSON.parse(item.popup)
        let isCourtCase = result.type === "processo_judicial_view"

        const riskItem = processedRiskItems?.find(risk => risk.id === item.id && isCourtCase);

        if (riskItem) {
            return {
                ...item,
                caseProgressHandler: caseProgressHandlerListRiskItems,
                caseProgressStatus: riskItem.caseProgressStatus
            };
        }
        return item;
    })

    setFilteredOptions(filterWithCaseProgress);
    
  }, [actualData, cortes, anos, polos, postponeStatus, caseProgress])

  useEffect(() => {
    if (
      showFilters &&
      !selectedCourts &&
      !selectedYears &&
      !selectedPolarities &&
      !selectedStatus
    ) {
      setCourts([... new Set(actualData.map((i) => {
        return i.coluna1;
      }))].sort((a, b) => {
        return a > b ? 1 : -1;
      }))
      setYears([... new Set(actualData.map((i) => {
        if (i?.coluna2?.includes('/') || i?.coluna2?.includes('-')) {
          return i?.coluna2?.substring(6,10);
        }
        return i?.coluna2?.substring(9, 13);
      }))].sort((a, b) => {
        return a < b ? 1 : -1;
      }))
      setPolarities([... new Set(actualData.map((i) => {
        return i.coluna3;
      }))].sort((a, b) => {
        return a > b ? 1 : -1;
      }))
      setStatus([... new Set(actualData.map((i) => {
        return i.coluna4;
      }))].sort((a, b) => {
        return a > b ? 1 : -1;
      }))
    }
  }, [actualData, selectedCourts, selectedYears, selectedPolarities, selectedStatus])

  return (
    <Accordion onChange={onOpen} columns={columns}>
      {isValidating ? <SimpleLoading /> : (
        <>
          {showFilters && (
            <AlignDivs>
              {filterCourties}
              {filterYears}
              {filterPolarities}
              {filterStatus}
            </AlignDivs>
          )}
          {filteredOptions?.length > 0 && (
            filteredOptions?.map((riskItem) => {
              return <RiskItem
                isProcess={showFilters}
                key={riskItem.id}
                type={itemRiskType}
                data={riskItem}
                riskSourceID={riskItem.riskId || riskItem.risk_source_id}
                themeID={riskItem.themeId}
              />
            })
          )}
        </>
      )}
    </Accordion>
  );
};

ItemRiskListEntry.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  columns: array.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  data: arrayOf(object),
  fetchUrl: string,
  itemRiskType: oneOf(['default', 'survey']),
  showFilters: boolean,
};

ItemRiskListEntry.defaultProps = {
  data: [],
  fetchUrl: null,
  itemRiskType: 'default',
  showFilters: false,
};

export default ItemRiskListEntry;
